import { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { api, type Acceptance } from '../../lib/api'
import { Loading, Alert } from '../../components/ui'
import AcceptanceDoc from './AcceptanceDoc'

/** 一次列印多張驗收單；每張在列印時自動另起一頁（見 styles.css 的 .print-doc + .print-doc） */
export default function AcceptancesBatchPrint() {
  const [params] = useSearchParams()
  const ids = (params.get('ids') ?? '').split(',').map((s) => s.trim()).filter(Boolean)

  const [list, setList] = useState<Acceptance[] | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    if (ids.length === 0) {
      setError('沒有選取任何驗收單')
      return
    }
    Promise.all(ids.map((id) => api.get<Acceptance>(`/acceptances/${id}`)))
      .then((all) => all.sort((a, b) => a.code.localeCompare(b.code)))
      .then(setList)
      .catch((e) => setError(e.message))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.get('ids')])

  return (
    <>
      <div className="page-head no-print">
        <h2>批次列印驗收單（{ids.length} 張）</h2>
        <div className="spacer" />
        <div className="btn-row">
          <button className="primary" onClick={() => window.print()} disabled={!list}>
            列印全部 / 存成 PDF
          </button>
          <Link to="/acceptances"><button>返回清單</button></Link>
        </div>
      </div>

      <Alert kind="error">{error}</Alert>

      {!error && !list && <Loading />}

      {list?.map((a) => (
        <div key={a.id} className="batch-item">
          {/* 作廢單不能拿去請款，這條橫幅跟單頁列印一樣要印出來 */}
          {a.voided_at && (
            <div
              style={{
                border: '2px solid var(--bad)', color: 'var(--bad)', fontWeight: 700,
                padding: '8px 12px', marginBottom: 12, textAlign: 'center',
              }}
            >
              本驗收單已於 {a.voided_at} 作廢，不得作為請款依據
              {a.void_reason ? `（原因：${a.void_reason}）` : ''}
            </div>
          )}
          <AcceptanceDoc a={a} />
        </div>
      ))}
    </>
  )
}
